import { FieldType } from "onefaceui-react-components";

export const getProjection = (
  firstResult,
  activeFields,
  maxResults = 51
) => {
  const fieldsList = ['id'];

  activeFields.forEach((field) => {
    if (field.type === FieldType.LOOKUP) {
      fieldsList.push(`${field.name}.id`);
      fieldsList.push(`${field.name}.${field.lookupParams?.column}`);
    } else {
      fieldsList.push(`${field.name}`);
    }
  });

  return {
    filters: fieldsList,
    firstResult,
    maxResults
  };
};
